// extracted by mini-css-extract-plugin
module.exports = {"cost-saving-Certified":"Certified_cost-saving-Certified____1m_"};